import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import LOGO_WHITE from "../assets/img/logos/logo_white.png";
import DESKTOP_LIGHT from "../assets/img/brand-logos/desktop-light.png";
import PNG2 from "../assets/img/authentication/2.png";
import LOGO from "../assets/img/brand-logos/desktop-logo.png";
import PNG8 from "../assets/img/authentication/firbase/1.png";
import BACKGROUND from "../assets/img/background/signin_back.png";

export const Connect = () => {
  return (
    <div className="flex justify-center min-h-screen align-middle">
      <Helmet>
        <html dir="ltr" className="h-full"></html>
        <body
          className="cover1 justify-center"
          style={{ backgroundImage: `url(${BACKGROUND})` }}
        ></body>
      </Helmet>
      <main id="content" className="w-full max-w-md mx-auto my-auto p-6">
        <Link to={`dashboards/sales/`} className="header-logo">
          <img src={LOGO_WHITE} alt="logo" className="mx-auto block" />
        </Link>
        <div className="mt-7 bg-white rounded-sm shadow-sm dark:bg-bgdark">
          <div className="p-4 sm:p-7">
            <div className="text-center">
              <h1 className="block text-2xl font-bold text-gray-800 dark:text-white">
                Stake Admin Dashboard
              </h1>
              <p className="mt-3 text-sm text-gray-600 dark:text-white/70">
                Connect the admin wallet to open dashboard.
              </p>
            </div>

            <div className="mt-5">
              <div>
                <div className="flex justify-center">
                  <w3m-button size="md" label="Connect" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
